import intlUtility from "../utils/intlUtility";
var intl = {
  init: intlUtility.init.bind(intlUtility),
  formatMessage: intlUtility.formatMessage.bind(intlUtility),
  formatNumber: intlUtility.formatNumber.bind(intlUtility),
  // formatDate: intlUtility.formatDate.bind(intlUtility),
  // formatTime: intlUtility.formatTime.bind(intlUtility),
  // formatRelativeTime: intlUtility.formatRelativeTime.bind(intlUtility),
  getIntl: intlUtility.getIntl.bind(intlUtility)
};
export default intl;